import { useState, useEffect } from 'react';
import { BrokerStatusChangeEvent } from '../../../../types';
import { getEvents } from '../../../../api/api';
import { Broker } from '@amzn/amazonmq-opsconsole-client';

function processEvents(events: BrokerStatusChangeEvent[]): Record<number, number | undefined> {
    if (!events || !events.length) {
        return {};
    }

    const sortedEvents = [...events].sort((a, b) => {
        const timeA = new Date(a.timeStamp).getTime();
        const timeB = new Date(b.timeStamp).getTime();
        return timeA - timeB;
    });

    const map: Record<number, number | undefined> = {};
    let currentStart: number | null = null;

    sortedEvents.forEach(event => {
        const eventTime = new Date(event.timeStamp).getTime();

        if (event.brokerState === "RESTART_IN_PROGRESS") {
            currentStart = eventTime;
            map[currentStart] = undefined;
        } else if (event.brokerState === "AVAILABLE" && currentStart !== null) {
            map[currentStart] = eventTime;
            currentStart = null;
        }
    });

    return map;
}

interface Props {
    broker: Broker,
    refreshCnt: number,
}

export const useRestartEvents = ({ broker, refreshCnt }: Props) => {
    const [restarts, setRestarts] = useState<Record<number, number | undefined>>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!broker.id) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        getEvents(broker.id)
            .then(response => {
                const processedRestarts = processEvents(response.events);
                setRestarts(processedRestarts);
            })
            .catch(error => {
                console.error(error);
                setError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [broker, refreshCnt]);

    return { restarts, loading, error };
};